import { api } from './api';
import type {
  SavedCompanyList,
  SavedCompany,
  CreateListRequest,
  AddCompanyToListRequest
} from '../../types/prospector/savedCompanies.types';

const BASE_URL = ''; // Using direct prospector API routes, base URL already included

/**
 * Service for managing saved company lists
 */
export const savedCompaniesApi = {
  // Get all lists for a user
  getLists: async (): Promise<SavedCompanyList[]> => {
    return api.get<SavedCompanyList[]>(`${BASE_URL}/lists`);
  },

  // Get a specific list by ID
  getListById: async (listId: number): Promise<SavedCompanyList> => {
    return api.get<SavedCompanyList>(`${BASE_URL}/lists/${listId}`);
  },

  // Create a new list
  createList: async (listData: CreateListRequest): Promise<SavedCompanyList> => {
    return api.post<SavedCompanyList>(`${BASE_URL}/lists`, listData);
  },

  // Update a list
  updateList: async (listId: number, listData: Partial<SavedCompanyList>): Promise<SavedCompanyList> => {
    return api.put<SavedCompanyList>(`${BASE_URL}/lists/${listId}`, listData);
  },

  // Delete a list
  deleteList: async (listId: number): Promise<void> => {
    return api.delete<void>(`${BASE_URL}/lists/${listId}`);
  },

  // Add a company to a list
  addCompanyToList: async (request: AddCompanyToListRequest): Promise<SavedCompany> => {
    return api.post<SavedCompany>(`${BASE_URL}/lists/${request.listId}/companies`, request.company);
  },

  // Bulk add companies to a list
  bulkAddCompaniesToList: async (listId: number, companies: any[]): Promise<{
    success: boolean;
    message: string;
    saved: number;
    errorCount: number;
    results: SavedCompany[];
    errors: any[];
  }> => {
    return api.post(`${BASE_URL}/lists/${listId}/companies/bulk`, { companies });
  },

  // Remove a company from a list
  removeCompanyFromList: async (listId: number, companyId: number): Promise<void> => {
    return api.delete<void>(`${BASE_URL}/lists/${listId}/companies/${companyId}`);
  },

  // Update saved company notes or status
  updateSavedCompany: async (listId: number, companyId: number, data: Partial<SavedCompany>): Promise<SavedCompany> => {
    return api.patch<SavedCompany>(`${BASE_URL}/lists/${listId}/companies/${companyId}`, data);
  }
};